import useCallableFunction from "@/hooks/useCallableFunction";

export default class User {
  constructor(obj) {
    this.id = obj.id || "";
    this.fullname = obj.fullname || "";
    this.avatar = obj.avatar || "";
    this.externalid = obj.externalid || "";
    this.description = obj.description || "";
    this.type = obj.type || "";
    this.password = obj.password || "";
    this.email = obj.email || "";
    this.phone = obj.phone || "";
    this.disabled = obj.disabled || false;
    this.recordings = obj.recordings || "";
    this.lang = obj.lang || navigator.language.substring(0, 5);
    this.recordEnabled = obj.recordEnabled || "both";
    this.storageUsed = obj.storageUsed || 0;
    this.isLocked = obj.isLocked || false;
  }

  static async getAll(companyId) {
    const getAllUsersInCompany = useCallableFunction(
      "api/getAllUsersInCompany"
    );
    const result = await getAllUsersInCompany({ companyId });
    return result.data;
  }

  static async update(user, companyId) {
    user.id = user.id + "@" + companyId;
    const userUpdate = useCallableFunction("api/userUpdate");
    const result = await userUpdate({ user });
    return result;
  }

  static async add(user, companyId) {
    user.id = user.id + "@" + companyId;
    const userAdd = useCallableFunction("api/userAdd");
    const result = await userAdd({ user });
    return result;
  }

  static async remove(user, companyId) {
    user.id = user.id + "@" + companyId;
    const userDelete = useCallableFunction("api/userDelete");
    const result = await userDelete({ user });
    return result;
  }

  static async unlock(user, companyId) {
    const userUnlock = useCallableFunction("api/userUnlock");
    const result = await userUnlock({ user: user.id, companyId });
    return result;
  }

  static async getUserData(id, company) {
    const getUserById = useCallableFunction("api/getUserById");
    const result = await getUserById({ user: id, company });
    return result.data;
  }
}
